import { render, staticRenderFns } from "./LoadsRefinesReport.vue?vue&type=template&id=0d3ec104"
import script from "./LoadsRefinesReport.vue?vue&type=script&lang=js"
export * from "./LoadsRefinesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports